angular.module("ainapp")
    .controller("bulkPurchaseEnquiryController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Bulk Purchase Enquiry";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Currencys = [];
            MainService.CurrencyInDropdown().then(function (response) {
                $scope.Currencys = response.data;
            })

            $scope.Units = [];
            MainService.UnitsInDropdown().then(function (response) {
                $scope.Units = response.data;
            });

            $scope.VATs = [];
            MainService.VATsInDropdown().then(function (response) {
                $scope.VATs = response.data;
            });


            /////////////// Linking ....///////////////

            $scope.init = function () {
                $scope.ExcelArray = [];
                $scope.ExcelArray2 = [];
            }

            $scope.init();


            var oFileIn;

            $(function () {
                oFileIn = document.getElementById('my_file_input');
                if (oFileIn.addEventListener) {
                    oFileIn.addEventListener('change', filePicked, false);
                }
            });

            function filePicked(oEvent) {
                var oFile = oEvent.target.files[0];
                var sFilename = oFile.name;
                var reader = new FileReader();

                $scope.ExcelArray = [];

                reader.onload = function (e) {
                    var data = e.target.result;
                    var cfb = XLSX.read(data, {
                        type: 'binary'
                    });
                    console.log(cfb)
                    cfb.SheetNames.forEach(function (sheetName) {
                        var sCSV = XLS.utils.make_csv(cfb.Sheets[sheetName]);
                        var oJS = XLS.utils.sheet_to_json(cfb.Sheets[sheetName]);

                        angular.forEach(oJS, function (e) {

                            var ttp = {

                                VoucherDate: new Date(e.VoucherDate),
                                VoucherNumber: e.VoucherNumber,
                                VendorCode: e.VendorCode,
                                VendorName: e.VendorName,
                                OrderNo: e.OrderNo,
                                Remarks: e.Remarks,
                                Currency: e.Currency,
                                Batch: e.Batch,
                                ProductCode: e.ProductCode,
                                ProductName: e.ProductName,
                                Description: e.Description,
                                Quantity: parseFloat(e.Quantity),
                                Unit: e.Unit,
                                VatType: e.VatType,
                                UnitPrice: parseFloat(e.UnitPrice),
                                Discount: parseFloat(e.Discount),
                                VAT: parseFloat(e.VAT),
                                OtherCharges: parseFloat(e.OtherCharges),
                                ExtraCharges: parseFloat(e.ExtraCharges),
                            }

                            angular.forEach($scope.Currencys, function (currency) {
                                if (ttp.Currency == currency.Name) {
                                    ttp.CurrencyId = currency.Id;
                                }
                            })

                            angular.forEach($scope.Units, function (u) {
                                if (ttp.Unit == u.Name) {
                                    ttp.UnitId = u.Id;
                                }
                            })
                            angular.forEach($scope.VATs, function (v) {
                                if (ttp.VAT == v.Value) {
                                    ttp.VATId = v.Id;
                                }
                            })

                            $scope.ExcelArray.push(ttp);
                            $scope.ExcelArray2 = [];

                            angular.forEach($scope.ExcelArray, function (arr) {
                                if ($scope.ExcelArray2.length == 0) {
                                    var obj = {
                                        VoucherNumber: arr.VoucherNumber,
                                        VoucherDate: arr.VoucherDate,
                                        VendorCode: arr.VendorCode,
                                        VendorName: arr.VendorName,
                                        OrderNo: arr.OrderNo,
                                        Remarks: arr.Remarks,
                                        Currency: arr.Currency,
                                        CurrencyId: arr.CurrencyId,
                                        Batch: arr.Batch,
                                        CommonVoucherDetails: [
                                            {
                                                ProductCode: arr.ProductCode,
                                                ProductName: arr.ProductName,
                                                Description: arr.Description,
                                                Quantity: arr.Quantity,
                                                Unit: arr.Unit,
                                                UnitId: arr.UnitId,
                                                VATId: arr.VATId,
                                                UnitPrice: arr.UnitPrice,
                                                Discount: arr.Discount,
                                                VAT: arr.VAT,
                                                VatType: arr.VatType,
                                                OtherCharges: arr.OtherCharges,
                                                ExtraCharges: arr.ExtraCharges,
                                            }
                                        ],
                                    }

                                    $scope.ExcelArray2.push(obj);
                                } else {

                                    var found = false;
                                    angular.forEach($scope.ExcelArray2, function (arr2) {
                                        if (arr2.Batch == arr.Batch) {
                                            var pdt = {
                                                ProductCode: arr.ProductCode,
                                                ProductName: arr.ProductName,
                                                Description: arr.Description,
                                                Quantity: arr.Quantity,
                                                Unit: arr.Unit,
                                                UnitId: arr.UnitId,
                                                VATId: arr.VATId,
                                                UnitPrice: arr.UnitPrice,
                                                Discount: arr.Discount,
                                                VAT: arr.VAT,
                                                VatType: arr.VatType,
                                                OtherCharges: arr.OtherCharges,
                                                ExtraCharges: arr.ExtraCharges,
                                            }
                                            arr2.CommonVoucherDetails.push(pdt);
                                            found = true;
                                        }
                                    })

                                    if (found == false) {


                                        var obj = {
                                            VoucherDate: arr.VoucherDate,
                                            VoucherNumber: arr.VoucherNumber,
                                            VendorCode: arr.VendorCode,
                                            VendorName: arr.VendorName,
                                            OrderNo: arr.OrderNo,
                                            Remarks: arr.Remarks,
                                            Currency: arr.Currency,
                                            CurrencyId: arr.CurrencyId,
                                            Batch: arr.Batch,
                                            CommonVoucherDetails: [
                                                {
                                                    ProductCode: arr.ProductCode,
                                                    ProductName: arr.ProductName,
                                                    Description: arr.Description,
                                                    Quantity: arr.Quantity,
                                                    Unit: arr.Unit,
                                                    UnitId: arr.UnitId,
                                                    VATId: arr.VATId,
                                                    UnitPrice: arr.UnitPrice,
                                                    Discount: arr.Discount,
                                                    VAT: arr.VAT,
                                                    VatType: arr.VatType,
                                                    OtherCharges: arr.OtherCharges,
                                                    ExtraCharges: arr.ExtraCharges,
                                            }
                                        ],
                                        }

                                        $scope.ExcelArray2.push(obj);

                                    }

                                }

                            })

                        });

                        $scope.$apply();
                        $scope.CalculateData();

                    });
                };

                reader.readAsBinaryString(oFile);



            }

            $scope.CalculateData = function () {
                angular.forEach($scope.ExcelArray2, function (e) {

                    e.GrandTotal = 0;
                    e.TotalTax = 0;
                    e.NetTotal = 0;
                    e.TotalExtraCharges = 0;

                    angular.forEach(e.CommonVoucherDetails, function (det) {

                        det.Total = det.Quantity * det.UnitPrice;
                        det.Total = Math.round(det.Total * 100) / 100;


                        if (det.VatType != "Exclusive") {


                            det.TaxValue = ((det.Total - det.Discount + det.OtherCharges) * det.VAT) / (100 + det.VAT);
                            det.TaxValue = Math.round(det.TaxValue * 1000) / 1000;
                            det.TaxableAmount = det.TaxableAmount - det.TaxValue;
                            det.TaxableAmount = Math.round(det.TaxableAmount * 1000) / 1000;


                        } else {

                            det.TaxableAmount = det.Total - det.Discount + det.OtherCharges;

                            det.TaxValue = det.TaxableAmount * (det.VAT / 100);
                            det.TaxValue = Math.round(det.TaxValue * 100) / 100;

                        }

                        det.RoundOfVat = det.TaxValue;
                        det.InventoryValue = det.TaxableAmount + det.RoundOfVat + det.ExtraCharges;

                        e.GrandTotal = e.GrandTotal + det.InventoryValue;
                        e.TotalTax = e.TotalTax + det.RoundOfVat;
                        e.NetTotal = e.NetTotal + det.TaxableAmount;
                        e.TotalExtraCharges = e.TotalExtraCharges + det.ExtraCharges;

                        $scope.$apply();
                    })

                })


            }



            $scope.saveBulkVouchers = function () {
                angular.forEach($scope.ExcelArray2, function (e) {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    $scope.load = true;

                    e.DateMonth = e.VoucherDate.getMonth() + 1;
                    e.DateDay = e.VoucherDate.getDate();
                    e.DateYear = e.VoucherDate.getFullYear();

                    MainService.AddPurchaseEnquiryBulk(e).then(function (response) {
                        $scope.load = false;
                        if (response.data.Message == "Success") {
                            toastr.success("Success, Batch No : " + e.Batch);

                            var index = $scope.ExcelArray2.indexOf(e);
                            $scope.ExcelArray2.splice(index, 1);
                            if ($scope.ExcelArray2.length == 0) {
                                $scope.init();
                            }

                        } else {
                            toastr.warning("Error, " + response.data.Message + " Batch No : " + e.Batch);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error, Batch No : " + e.Batch);
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    })

                })
            }



        }])
